<template>
  <div>
    <!-- Sin título propio: la barra superior del layout ya muestra "Mi Perfil". -->
    <base-header class="pb-6 pb-8 pt-5 pt-md-8" />
    <b-container fluid class="mt--7">
      <b-col lg="8" md="10">
        <!-- Sin recuadro gris: el formulario va directo sobre el fondo de la página. -->
        <b-card no-body class="bg-transparent border-0 shadow-none mb-0">
          <b-card-body class="px-lg-5 py-lg-5">
            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <b-form role="form" @submit.prevent="handleSubmit(update)">

                <h4 class="mt-4">{{ $t('informacion_personal') }}</h4>

                <base-button :type="editMode ? 'danger' : 'warning'" @click="cancelEdit" class="my-4">{{
                  editMode
                    ? $t('cancelar') : $t('editar') }}
                </base-button>
                <base-button v-if="editMode" type="primary" native-type="submit" class="my-4">{{ $t('guardar') }}</base-button>
                <b-row>
                  <b-col md="6">
                    <p class="p-login">{{ $t('nombre') }}</p>
                    <b-form-input class="mb-3" v-model="user.nombre" :disabled="!editMode" />
                  </b-col>
                  <b-col md="6">
                    <p class="p-login">{{ $t('apellido') }}</p>
                    <b-form-input class="mb-3" v-model="user.apellidoP" :disabled="!editMode" />
                  </b-col>
                  <b-col md="6">
                    <p class="p-login">{{ $t('correo_electronico') }}</p>
                    <b-form-input class="mb-3" v-model="user.correo" disabled />
                  </b-col>
                  <b-col md="6">
                    <p class="p-login">{{ $t('telefono') }}</p>
                    <b-form-input class="mb-3" v-model="user.telefono" :disabled="!editMode" />
                  </b-col>
                  <b-col md="6">
                    <p class="p-login">{{ $t('locacion') }}</p>
                    <b-form-select class="mb-3" v-model="user.idPais" :disabled="!editMode">
                      <option :value="null">{{ $t('seleccione_opcion') }}</option>
                      <option v-for="op in opcionesPaises" :key="op.value" :value="op.value">
                        {{ op.text }}
                      </option>
                    </b-form-select>
                  </b-col>
                </b-row>

                <base-button v-if="editMode && !editPass" @click.prevent="editPass = !editPass;" class="my-4" :type="editPass ? 'danger' : 'info'">
                  {{ editPass ? $t('cancelar') : $t('editar_contrasena') }}
                </base-button>
                <b-row>
                  <b-col v-if="editPass" md="6">
                    <b-form-group label-for="password">
                      <template v-slot:label>
                        {{ $t('contrasena') }} <span class="text-danger">*</span>
                      </template>
                      <div class="input-group">
                        <b-form-input :disabled="!editMode" @blur="validatePassword" @change="validatePassword"
                          class="border rounded-left" required :placeholder="$t('contrasena')"
                          :type="showPassword ? 'text' : 'password'" v-model="user.password"></b-form-input>
                        <div class="input-group-append">
                          <button class="btn btn-outline-secondary border rounded-right" type="button"
                            @click="togglePassword">
                            <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                          </button>
                        </div>
                      </div>
                      <span v-if="passwordError" style="color: red; font-size: 12px;">{{ $t('contrasena_caracteres') }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="editPass" md="6">
                    <b-form-group label-for="confirmPassword">
                      <template v-slot:label>
                        {{ $t('confirmar_contrasena') }} <span class="text-danger">*</span>
                      </template>
                      <div class="input-group">
                        <b-form-input :disabled="!editMode" @blur="validatePassword" @change="validatePassword"
                          class="border rounded-left" required :placeholder="$t('confirmar_contrasena')"
                          :type="showPassword ? 'text' : 'password'" v-model="confirmPassword"></b-form-input>
                      </div>
                      <span v-if="passwordError2" style="color: red; font-size: 12px;">{{ $t('contrasena_caracteres') }}</span>
                      <span v-else-if="!passwordMatch" style="color: red; font-size: 12px;">{{ $t('contrasena_iguales') }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-card-body>
        </b-card>
      </b-col>
    </b-container>
  </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import userService from '@/api/userService'
import utilsService from '../../api/utilsService.vue'
import zonaService from '@/api/zonaService'

export default {
  name: 'UserProfile',
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      user: {},
      opcionesPaises: [],
      editMode: false,
      editPass: false,
      showPassword: false,
      confirmPassword: '',
      passwordError: false,
      passwordError2: false,
      passwordMatch: true,
    };
  },
  async beforeMount() {
    await this.initData();


  },
  methods: {
    async cancelEdit() {
      if (this.editMode) {
        await this.initData();
      }
      this.editMode = !this.editMode;
      this.editPass = false;

    },
    async initData() {
      const user = utilsService.getUserInfo();
      this.user = await userService.getPerfil(user.id);
      this.opcionesPaises = await zonaService.getPaisesOptions();
    },
    async update() {
      Swal.fire({
        title: '¿Está seguro de guardar?',
        text: 'Verifique que todos los datos sean correctos',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            Swal.fire({
              html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                  <div>
                      <h3 style="color: #006393;">Guardando...</h3>
                  </div>
              </div>`,
              showConfirmButton: false,
              allowOutsideClick: false
            });
            const id = utilsService.getUserInfo().id;
            const response = await userService.update(this.user, id);
            if (!response) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: 'Ocurrió un error al crear el ingreso, intente nuevamente.'
              });
              return;
            }

            Swal.fire({
              title: "Guardado correctamente",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              background: '#f8f9fa',
              customClass: {
                title: 'swal-title',
                icon: 'swal-icon',
              },
            });
            this.editMode = false;
            this.editPass = false;
            await this.initData();

          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.message
            });
          }
        }
        else if (result.isDenied) {
          Swal.close();
        }
      });
    },
    validatePassword() {
      this.passwordError = this.user.password.length < 5;
      this.passwordError2 = this.confirmPassword.length < 5;
      this.passwordMatch = this.user.password === this.confirmPassword;
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
  }
}
</script>

<style scoped>
.p-login {
  margin-bottom: 0;
}
</style>
